import styled, { css } from 'styled-components';
import { Select } from 'antd';

type IErrors = {
    errors?: string[];
    options: any[];
};

export const StyledSelect: React.FC<IErrors> = styled(Select)<IErrors>`
    && {
        ${({ errors, theme }) => css`
            width: 100%;
            &:hover,
            &:focus {
                ${(!errors || errors.length === 0) &&
                css`
                    border-color: ${theme.colors.accentColor};
                `};
            }

            ${errors &&
            errors.length > 0 &&
            css`
                border-color: ${theme.colors.fail} !important ;
            `};
        `}
    }
`;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;
